export class DocFile {

    constructor(data: DocFile) {
        this.applicantDocumentId = data.applicantDocumentId;
        this.applicantEnrollmentId = data.applicantEnrollmentId;
        this.documentVersionId = data.documentVersionId;
        this.fileName = data.fileName;
        this.applicantStepId = data.applicantStepId;
    }

    applicantDocumentId?: number | undefined;
    applicantEnrollmentId?: number | undefined;
    documentVersionId?: number | undefined
    fileName?: string | undefined;
    applicantStepId: number | undefined
    status: string | undefined;
    fileData: Uint8Array | undefined;
    url: string | undefined;

    // Populated only by the single-document endpoint (GET /api/documents/{applicantDocumentId}/{applicantStepId?})
    required?: boolean;
    embedUrl?: string;
    base64Data?: string;
    documentTypeId?: number;
    enrollmentReviewed?: boolean;
    /** False for a document the student only reads (nothing to sign): the viewer then shows no signing state. */
    signingRequired?: boolean | null;
}


/**
 * A document being prepared in the background (202 from the endpoints that generate a document for signing). Poll
 * `enrollmentApi.getDocumentJob` until `status` is "succeeded" (then open `applicantDocumentId`) or "failed".
 */
export interface DocumentJobInfo {
    jobId: number;
    status: "queued" | "running" | "succeeded" | "failed";
    applicantDocumentId?: number | null;
    /** The last attempt failed because of PandaDoc; the job keeps retrying in the background. */
    pandaDocUnavailable?: boolean;
    message?: string | null;
    attempts?: number;
}

export function isDocumentJob(value: unknown): value is DocumentJobInfo {
    return !!value && typeof value === "object" && typeof (value as DocumentJobInfo).jobId === "number";
}


export class EnrollmentDocumentsInfoDto {
    constructor(data?: Partial<EnrollmentDocumentsInfoDto>) {
        this.reviewed = data?.reviewed ?? false;
        this.preparing = data?.preparing ?? false;
        this.applicantEnrollmentId = data?.applicantEnrollmentId ?? null;
        this.statusId = data?.statusId ?? null;
        this.status = data?.status ?? null;
        this.documents = (data?.documents ?? []).map(d => new DocFile(d as DocFile));
    }

    reviewed: boolean;
    /**
     * The applicant has an enrollment but its documents have not been created yet. They are created in the background
     * right after Admin creates the enrollment, so this is normally brief; show a message, not an empty list.
     */
    preparing: boolean;
    applicantEnrollmentId: number | null;
    statusId: number | null;
    status: string | null;
    documents: DocFile[];
}